import faqAccordion from "./modules/faqAccordion";
import programTab from "./modules/programTab";
import voiceSlider from "./modules/voiceSlider";
import highlightParallax from "./modules/highlightParallax";
import programDetailSlider from "./modules/programDetailSlider";
import programCard from "./modules/programCard";
import mvSlider from "./modules/mvSlider";
import anchorScroll from "./modules/anchorScroll";
import scrollToTop from "./modules/scrollToTop";
import headerEntryMenu from "./modules/headerEntryMenu";
import { inview } from "./modules/inview";

window.AppInit = window.AppInit || {};
window.AppInit.faqAccordion = faqAccordion;
window.AppInit.programDetailSlider = programDetailSlider;
window.AppInit.programCard = programCard;

document.addEventListener("DOMContentLoaded", () => {
  inview(".inview", {
    rootMargin: "-15% 0px",
  });
  inview(".inview-custom", {
    rootMargin: "-15% 0px",
  });
  inview(".inview-opacity", {
    rootMargin: "-15% 0px",
  });
  inview(".bg-gradient-mask", {
    rootMargin: "0px",
  });
  anchorScroll();
  window.AppInit.faqAccordion();
  headerEntryMenu();
  programTab();
  voiceSlider();
  highlightParallax();
  window.AppInit.programDetailSlider();
  window.AppInit.programCard();
  mvSlider();
  scrollToTop();
});
